<template>
  <div class="appContainer"  >
    <AppAside></AppAside>
    <AppHeader></AppHeader>
    <AppMain v-loading="loading" element-loading-text="加载中"></AppMain>
  </div>
</template>

<script>
  import AppHeader from './AppHeader';
  import AppAside from './AppAside';
  import AppMain from './AppMain';
  // import AppFooter from './AppFooter';
  
  export default {
    name: 'Layout',
    components: {
      AppHeader,
      AppAside,
      AppMain
      // AppFooter
    },
    computed: {
      loading () {
        return this.$store.state.settings.screenLoading;
      }
    }
  };
</script>

<style>

</style>
